import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ImpersonationService } from './impersonation.service';

/**
 * Registered AFTER the library's own authInterceptor() in app.config.ts so this has the last
 * word: while impersonation is active, every call to a secure route (the same set auth-config.ts
 * guards — environment.apiUrl and environment.brokerAuthority) is overridden to carry the
 * impersonation token instead of the real session's own token. Falls through untouched otherwise,
 * so this has zero effect on the normal, non-impersonating path.
 */
export const impersonationInterceptor: HttpInterceptorFn = (req, next) => {
  const impersonationService = inject(ImpersonationService);
  const token = impersonationService.accessToken();

  if (!token) {
    return next(req);
  }

  const isSecureRoute = [environment.apiUrl, environment.brokerAuthority].some(
    (route) => route.length > 0 && req.url.startsWith(route),
  );

  if (!isSecureRoute) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
